import React from 'react';

export function SpendingListItem({label = 'Label', description = null, value = null}){
    return (
        <div className='flex justify-between items-center gap-4 relative w-full px-4 h-14 even:bg-white odd:bg-slate-50 rounded-xl dark:even:bg-slate-950 dark:odd:bg-slate-900'>
            <div className='flex flex-col w-auto min-w-0'>
                <span className='text-slate-950 font-medium dark:text-white'>{label}</span>
                {description && <span className='text-slate-500 dark:text-slate-400 text-xs font-medium truncate text-ellipsis overflow-hidden'>{description}</span>}
            </div>
            {value && <span className='text-slate-950 font-semibold dark:text-white'>{value}</span>}
        </div>
    );
}

export function SpendingList({children}){
    return (
        <div className='flex flex-col relative'>
            {children}
        </div>
    );
}